<template>
  <div id="audioPlayerWrapper" refs="audioPlayerWrapper" :class="[elClassProp]">
    <div v-if="playlist.songs.length" class="player-contents-wrap">
      <div class="controls">
        <div class="skip-backward">
          <div class="icon" @click="skip('backward')">
            <el-icon><ArrowLeft /></el-icon>
          </div>
        </div>

        <div class="play">
          <el-button v-if="!isPlaying" class="cstm-icon-btn-medium play_white_bacgkround" @click="playCurrentSong"></el-button>
          <el-button v-else class="cstm-icon-btn-medium cstm-icon-btn-medium pause_white_bacgkround" @click="pause"></el-button>
        </div>

        <div class="skip-forward">
          <div class="icon" @click="skip('forward')">
            <el-icon><ArrowRight /></el-icon>
          </div>
        </div>
      </div>

      <div class="seek">
        <template v-if="!parentComponentItemSelection.length && !isPlaying">
          <div class="playlist-details">
            <div class="pd-item number-of-songs">
              <div class="figure">{{playlistSummary.numberOfSongs}}</div>
              <div class="label">{{$t('label.song', playlistSummary.numberOfSongs)}}{{', '}}</div>
            </div>

            <template v-if="playlistSummary.hours <= 0 && playlistSummary.minutes <= 0 && playlistSummary.seconds > 0">
              <div class="pd-item seconds">
                <div class="figure">{{playlistSummary.seconds}}</div>
                <div class="label">{{$t('label.timeShorthandSecond')}}</div>
              </div>
            </template>
            <template v-else-if="playlistSummary.hours <= 0 && playlistSummary.minutes > 0 && playlistSummary.seconds > 0">
              <div class="pd-item min">
                <div class="figure">{{playlistSummary.minutes}}</div>
                <div class="label">{{$t('label.timeShorthandMinute')}}</div>
              </div>
              <div class="pd-item seconds">
                <div class="figure">{{playlistSummary.seconds}}</div>
                <div class="label">{{$t('label.timeShorthandSecond')}}</div>
              </div>
            </template>
            <template v-else-if="playlistSummary.hours <= 0 && playlistSummary.minutes > 0 && playlistSummary.seconds <= 0">
              <div class="pd-item min">
                <div class="figure">{{playlistSummary.minutes}}</div>
                <div class="label">{{$t('label.timeShorthandMinute')}}</div>
              </div>
            </template>
            <template v-else>
              <div class="pd-item hours">
                <div class="figure">{{playlistSummary.hours}}</div>
                <div class="label">{{$t('label.timeShorthandHour')}}</div>
              </div>
              <div class="pd-item min">
                <div class="figure">{{playlistSummary.minutes}}</div>
                <div class="label">{{$t('label.timeShorthandMinute')}}</div>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="start-time">
            <template v-if="enableCumulativeTime && isPlaying">
              {{cumulativeCurrentPlayedTime}}
            </template>
            <template v-else>
              {{currentPlayedTime}}
            </template>
          </div>
          <div class="progress-container">
            <div class="progress" id="progress-wrap">
              <div class="progress-handle" :style="{left:progressPercentageValue}"></div>
              <div class="transparent-seeker-layer" @click="seek"></div>
              <div class="bar" :style="{width:progressPercentageValue}"></div>
            </div>
          </div>

          <div class="end-time">{{duration}}</div>
        </template>
      </div>
    </div>
    <audio ref="audiofile" :src="defaultSong" preload style=" display: none" controls></audio>
  </div>
</template>

<script src="./audio-player.js"></script>
<style lang="scss" src="./audio-player.scss"></style>
